import { Component, EventEmitter, Input, Output } from '@angular/core';

// comment.model.ts (create this file or place it in the same file as the component)
export interface MetaInfo {
    createdByName: string;
    createdAt: Date;
}

@Component({
    selector: 'company-editor-meta-info',
    template: `
        <div class="meta-user-container">
            <div class="meta-user">
                <ham-avatar type="circle" size="regular" [fullName]="meta.createdByName"></ham-avatar>
            </div>
            <div class="meta-created">
                <div class="created-by">{{ meta.createdByName }}</div>
                <div class="created-at">
                    {{ 'aumico_companies_form_assigned_on' | i18next }} {{ meta.createdAt | dateLocale }}
                </div>
            </div>
            <span class="ham-icon" style="margin-left: auto;" (click)="close.emit()"><i class="x-circle-filled-icon"></i></span>
        </div>
    `,
    styleUrls: ['./company-meta-info.component.scss'],
})
export class CompanyMetaInfoComponent {
    @Input() meta!: MetaInfo; // Use the interface for the input property
    @Output() close = new EventEmitter<void>();
}
